const EXTENSION_ID = 'kdkgijnijnbincicbnopccopncfedgba';
const EXTENSION_WEBSTORE_URL = `https://chrome.google.com/webstore/detail/${EXTENSION_ID}`;
export const getWebstoreUrl = () => EXTENSION_WEBSTORE_URL;
export const isInstalled = async () => {
    const imgUrl = `chrome-extension://${EXTENSION_ID}/icons/16.png`;
    try {
        await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = async () => {
                resolve(img);
            };
            img.onabort = reject;
            img.onerror = reject;
            img.src = imgUrl;
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
export const requestInstall = (onInstall) => {
    window.open(EXTENSION_WEBSTORE_URL, '_blank');
    const onVisibilityChange = async () => {
        if (document.visibilityState === 'visible') {
            const isHelperInstalled = await isInstalled();
            if (isHelperInstalled) {
                window.removeEventListener('visibilitychange', onVisibilityChange);
                onInstall();
            }
        }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
};
